import React from 'react'

const Partners = () => {
  const partners = [
    {
      id: 1,
      name: "King Ocean",
      logo: "https://kingocean.com/wp-content/uploads/2024/02/KING-OCEAN-LOGO-2019-WEB.png", 
      description: "Contracted rates for lower shipping costs.",
      link: "https://kingocean.com/", 
      isActive: true
    },
    {
      id: 2,
      name: "EasyPayday",
      logo: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSyodRjiHmiSKNvHts9GY3GpOimGs7Azet3Gg&s", 
      description: "Flexible local financing for your imports.",
      link: "https://easypayday.online/onboarding?inviteToken=e97fbc6c5879aa1794e831119e09bcc516abc9d46345a2bd2d9540dd55d806cd27137440:f0b12824876d34e7fe0cc7f77ef13a1d",
      isActive: true
    },
    {
      id: 3,
      name: "Chamber",
      logo: "https://static.wixstatic.com/media/9bab10_3c5b105d6a9b4a60b5a2f632b77a9966~mv2.png/v1/fill/w_348,h_348,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/BCCEC%20LOGO-ACRONYM%20ONLY-png.png",
      description: "Verified, compliant, and recognized",
      link: "https://www.thebahamaschamber.com/", 
      isActive: true
    }
  ]

  return (
    <div id="discover" className="pb-16 lg:pb-20 w-full bg-secondary-gray scroll-mt-[90px] lg:scroll-mt-[140px]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-12">
          <h2 className="font-urbanist text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
            Trusted Regional & Global Affiliations
          </h2>
          <p className="font-urbanist text-lg lg:text-xl text-gray-600 max-w-3xl mx-auto">
            Building your Caribbean supply chain through recognized, credible institutions.
          </p>
        </div>

        {/* Partners */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 lg:gap-12">
          {partners.filter(partner => partner.isActive).map((partner) => (
            <div key={partner.id} className="bg-white rounded-xl shadow-lg p-6 lg:p-8 text-center hover:shadow-xl transition-shadow duration-300">
              {/* Logo */}
              <div className="mb-6">
                <img 
                  src={partner.logo} 
                  alt={`${partner.name} logo`}
                  className="mx-auto h-16 lg:h-20 w-auto object-contain"
                />
              </div>
              
              {/* Partner Name */}
              <h3 className="font-urbanist text-xl lg:text-2xl font-semibold text-gray-900 mb-4">
                {partner.name}
              </h3>
              
              {/* Description */}
              <p className="font-urbanist text-sm lg:text-base text-gray-600 mb-6 leading-relaxed">
                {partner.description}
              </p>
              
              {/* Link Button */}
              {partner.link && partner.link !== "#" && (
                <a
                  href={partner.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-block bg-[#CA0000] text-white font-urbanist font-semibold px-6 py-3 rounded-full hover:bg-[#B80000] transition-colors duration-300"
                >
                  Learn More
                </a>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default Partners
